<ng-container *ngIf="selectedTariff || isAddTariff">
  <div class="tariff-wrapper">
    <div class="row">
      <ejs-tab #tabGroup Selecting="Select" id="element" class="mt-2" [animation]="animation" heightAdjustMode="fill"
        (selecting)="select($event)">
        <e-tabitems>
          <e-tabitem>
            <ng-template #headerText>
              {{'i18n.domain.administration.tariff-details.general' | translate}}
              <span class="icon-warning--alt text-warning ms-2" *ngIf="tariffForm.controls.general.invalid"></span>
            </ng-template>
            <ng-template #content>
              <app-tariff-details-general [generalFormGroup]="tariffForm.controls.general"></app-tariff-details-general>
            </ng-template>
          </e-tabitem>

          <e-tabitem>
            <ng-template #headerText>
              {{'i18n.domain.administration.tariff-details.prices' | translate}}
              <span class="icon-warning--alt text-warning ms-2" *ngIf="tariffForm.controls.prices.invalid"></span>
            </ng-template>
            <ng-template #content>
              <app-tariff-details-prices [priceFormGroup]="tariffForm.controls.prices"
                [maxParkingDuration]="maxParkingDuration"></app-tariff-details-prices>
            </ng-template>
          </e-tabitem>

          <e-tabitem [visible]="!isAddTariff">
            <ng-template #headerText>
              {{'i18n.domain.administration.tariff-details.zones' | translate}}
            </ng-template>
            <ng-template #content>
              <app-tariff-details-zones [assignedZones]="selectedTariff?.assignedZones"></app-tariff-details-zones>
            </ng-template>
          </e-tabitem>

          <e-tabitem>
            <ng-template #headerText>
              {{'i18n.domain.administration.tariff-details.blacklist' | translate}}
            </ng-template>
            <ng-template #content>
              <app-tariff-details-blacklist (blacklistLicensePlatesChange)="
                onBlacklistLicensePlatesChange($event)"
                [blacklist]="selectedTariff?.blacklistedLicensePlates"></app-tariff-details-blacklist>
            </ng-template>
          </e-tabitem>
        </e-tabitems>
      </ejs-tab>

    </div>
    <div class="detail-footer p-2 pt-3">
      <button type="button" class="btn btn-danger me-auto" (click)="deleteTariff()" *ngIf="selectedTariff"
        [disabled]="isReadonly || isBusy">
        {{'i18n.domain.administration.tariff-details.messages.delete-title' | translate}}
      </button>
      <button type="button" class="btn btn-secondary me-2" (click)="onCancelClicked()" [disabled]="isBusy">
        {{cancelButtonText | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="submitForm()"
        [disabled]="(isReadonly && !tariffForm.controls.blacklist.dirty) || saveButtonDisabled || isBusy">
        {{'i18n.shared.save' | translate}}
      </button>
    </div>
  </div>
</ng-container>
